// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getVideoCreatorListFailed, getVideoCreatorListRequested, getVideoCreatorListSucceeded } from './select-video-creator.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';

@Injectable()
export class SelectVideoCreatorEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getVideoCreatorListRequested),
      mergeMap(() => this.service.getVideoCreatorList()
        .pipe(
          map((response) => getVideoCreatorListSucceeded({response})),
          catchError(() => of(getVideoCreatorListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
  ) {
  }
}
